import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../commons/component/PageHeader/PageHeader';
import OfficesWorkspace from '../../components/Turnero/Offices/OfficesWorkspace/OfficesWorkspace.Component';

// styles
import './Offices.Details.Styles.css';

/**
 * Sucursales (Offices): sedes, sectores, consultorios y displays del turnero.
 * El PageHeader va como hijo directo de `.content` (igual que en el resto de las páginas): los
 * estilos pegajosos de App.css (`.content > .PageHeader`) dependen de eso.
 * Toda la lógica vive en `OfficesWorkspace` (componente → acción → middleware → servicio).
 */
const OfficesPage = () => {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('Offices.title')} />
      <div className="OfficesPage">
        <OfficesWorkspace />
      </div>
    </>
  );
};

export default OfficesPage;
